import React, { useEffect, useMemo, useState } from 'react';
import { Markdown as MD } from '@features/markdown/components/Markdown';
import Element from './Element';
import { zarazService } from "@/services";
import {useMediaQuery} from "react-responsive";
import {Breakpoints} from "@settings";
import Anchor from '@components/tailwind/Anchor';
import Link from './Link';

const Links = ({ attributes: { title, url, trackAs }, children = [], ...props }) => {
    return (<div className='tw-flex-1 tw-space-y-2.5 tw-whitespace-nowrap'>
        <Anchor
            href={url}
            title={trackAs}
            className='tw-mb-4 tw-block tw-w-full tw-border-b tw-border-[#C6C4BA] tw-font-body tw-text-sm tw-font-bold tw-text-neutrals-graphite !tw-no-underline hover:tw-text-neutrals-graphite'
            onClick={() => {
              zarazService.ecommerce.productClicked('main_nav', 'Main Nav', {name: trackAs || title})
            }}>
            {title}
        </Anchor>

        {children.map((c, i) => <Link key={i} {...c}/>)}
    </div>);
};

export default Links;
